import React from 'react';
import {BMC_BLOCKS} from './bmc_constants';

function BmcBlockIcon({block}) {
    let iconClassName = '';

    switch (block) {
        case BMC_BLOCKS.KEY_PARTNERS:
            iconClassName = 'fa fa-link';
            break;
        case BMC_BLOCKS.COST_STRUCTURE:
            iconClassName = 'fa fa-bar-chart';
            break;
        case BMC_BLOCKS.REVENUE_STREAMS:
            iconClassName = 'fa fa-usd ';
            break;
        case BMC_BLOCKS.KEY_RESOURCES:
            iconClassName = 'fa fa-industry ';
            break;
        case BMC_BLOCKS.KEY_ACTIVITIES:
            iconClassName = 'fa fa-check-circle ';
            break;
        case BMC_BLOCKS.KEY_PROPOSITIONS:
            iconClassName = 'fa fa-gift';
            break;
        case BMC_BLOCKS.CUSTOMER_RELATIONSHIPS:
            iconClassName = 'fa fa-heartbeat ';
            break;
        case BMC_BLOCKS.CHANNELS:
            iconClassName = 'fa fa-truck ';
            break;
        case BMC_BLOCKS.CUSTOMER_SEGMENTS:
            iconClassName = 'fa fa-users ';
            break;
        default:
            break;
    }

    return (
        <i className={iconClassName} aria-hidden="true"/>
    );
}

export default(BmcBlockIcon);